import { getWindow } from "@utils/browser-features";

export const sessionStorageRecoilSync = (key: string) => {
  return ({ setSelf, onSet }): void => {
    if (getWindow()?.sessionStorage) {
      const savedValue = sessionStorage.getItem(key);
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
    }

    onSet((newValue, _, isReset): void => {
      isReset
        ? sessionStorage.removeItem(key)
        : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };
};
